module.exports = __webpack_public_path__ + "static/media/h7.f0aed7c3.png";